import {
    fetch_detail,
    fetch_related_items,
} from "../../actions/Detail/dispatchers";
import { setPathingAppState, setAppError } from "../../actions/App/dispatchers";
import { reset_right_rail } from "../../reducers/RightRail/reducer";
import { fetch_supplementary_data } from "../../actions/RightRail/dispatchers";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";
import {
    metaPreviewReplacer,
    metaNinePreviewReplacer,
    previewType,
} from "../../utils/page/library";
import { fetch_some_newsletters } from "../../actions/Newsletters/actions";

export const fetchDetailPageData = (path, params) => (dispatch, getState) => {
    const { contentId, section } = params;
    const preview = previewType(path);
    let newPath;
    if (!preview) {
        newPath = path;
    } else {
        newPath =
            preview === "nine"
                ? metaNinePreviewReplacer(path)
                : metaPreviewReplacer(path);
    }

    const fetch_content_data = fetch_detail(contentId, preview);

    // Filter out episode part of path since fetch_supplementary_data
    // needs to fetch against a department
    //
    // Ex. URL: /radio/asithappens/as-it-happens-thursday-edition-1.6450714/she-s-19-and-just-finished-law-school-now-she-wants-to-fix-the-u-s-education-system-1.6451333
    const cleanSection = /\d.\d+$/.test(section)
        ? section.substr(0, section.lastIndexOf("/"))
        : section;

    return Promise.all([
        dispatch(reset_app_state(newPath, contentId)),
        dispatch(reset_right_rail()),
        dispatch(fetch_content_data),
        dispatch(fetch_supplementary_data(cleanSection)),
    ])
        .then(() => {
            const promises = [
                dispatch(setPathingAppState(newPath, false, contentId)),
                dispatch(fetch_related_items()),
            ];
            const state = getState();
            const newsletter = state?.detail?.content?.newsletter;

            if (newsletter && newsletter !== "false") {
                promises.push(dispatch(fetch_some_newsletters(newsletter)));
            }

            return Promise.all(promises);
        })
        .catch((error) => {
            dispatch(setAppError(newPath, error.code));
        });
};
